import type { SegmentCondition } from '@/pages/SegmentRuleFields'

export function eventSegmentPath(eventId: number) {
  const conditions = ['event_attendee', 'event_buyer'].map((field) => ({
    field,
    operator: 'is_not',
    values: [eventId],
  }))
  return `/communication/audiences/segments/new?${new URLSearchParams({ conditions: JSON.stringify(conditions) })}`
}

export function segmentEventPrefill(): SegmentCondition[] {
  try {
    const conditions: unknown = JSON.parse(
      new URLSearchParams(window.location.search).get('conditions') ?? '[]',
    )
    return Array.isArray(conditions) ? conditions.filter(isEventCondition) : []
  } catch {
    return []
  }
}

function isEventCondition(value: unknown): value is SegmentCondition {
  if (!value || typeof value !== 'object') return false
  const condition = value as SegmentCondition
  return (
    ['event_attendee', 'event_buyer', 'event_checked_in'].includes(condition.field) &&
    ['is', 'is_not'].includes(condition.operator) &&
    Array.isArray(condition.values) &&
    condition.values.every((id) => typeof id === 'number' && Number.isSafeInteger(id) && id > 0)
  )
}
